import { Box } from "@chakra-ui/react"

export const ContentAccordionRight = ({ children }) => {
  return (
    <Box flex="0 1 50%" borderLeft="1px solid" borderColor="blackAlpha.200" py="10" px="12" fontSize="md">
      {children}
    </Box>
  )
}
